/**
 * A warning, not a block.
 *
 * Paying against an existing customer renews or reactivates what they already
 * have — it does not open a second account. The rep may well intend exactly
 * that, so this states the consequence and gets out of the way.
 */
const ExistingCustomerNotice = ({ customer, compact }) => {
  if (!customer) return null;

  const name = customer.name || customer.email || "This contact";
  const status = customer.subscription_status;

  return (
    <div
      style={{
        background: "#fffbeb",
        border: "1px solid #fde68a",
        borderRadius: 10,
        padding: compact ? "10px 12px" : "12px 14px",
        marginTop: compact ? 0 : 14,
        fontSize: compact ? 12.5 : 12,
        color: "#92400e",
        lineHeight: 1.6,
      }}
    >
      <b>Existing customer — {name}</b>
      {status && (
        <span style={{ color: "#b45309" }}> · subscription {status}</span>
      )}
      <div style={{ marginTop: 4 }}>
        Payment will renew or reactivate this account, not create a new one.
      </div>
    </div>
  );
};

export default ExistingCustomerNotice;
